import PropTypes from 'prop-types';
import React from 'react';

import { CloseX, PlusCircle } from '@vimeo/bokeh-icons';

import styles from './CollapsableContent.module.scss';

class CollapsableContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { toggled: props.isActive || false };
    this.handleClick = this._handleClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.isActive && !prevProps.isActive && !this.state.toggled) {
      this.setState({ toggled: true });
    }
  }

  _handleClick(event) {
    let toggled = !this.state.toggled;
    this.setState({ toggled: toggled });

    if (!toggled && this.props.onClickClose) {
      this.props.onClickClose(event, toggled);
    } else {
      // since a div doesn't support the href attribute, we'll need to update the location hash here
      if (this.props.href) {
        window.location.hash = this.props.href;
      }

      if (this.props.onClickOpen) {
        this.props.onClickOpen(event, toggled);
      }
    }
  }

  getLabel(label) {
    return (
      <div className={styles.label}>
        <span className={styles.collapsable_header} onClick={this.handleClick}>
          <span className={styles.toggle_icon}>
            {!this.state.toggled ? (
              <PlusCircle className={styles.resource_toggle} />
            ) : (
              <CloseX className={styles.resource_toggle} />
            )}
          </span>
          <span>{label}</span>
        </span>
        {this.props.secondaryElement && <span>{this.props.secondaryElement}</span>}
      </div>
    );
  }

  render() {
    const { element, indented, label, ...filteredProps } = this.props;

    let Element = element;

    return (
      <div>
        {element ? (
          <Element {...filteredProps}>{this.getLabel(label)}</Element>
        ) : (
          <div {...filteredProps}>{this.getLabel(label)}</div>
        )}

        {this.state.toggled && (
          <div className={indented && styles.indented_collapsable_content}>
            {this.props.children}
          </div>
        )}
      </div>
    );
  }
}

CollapsableContent.defaultProps = {
  indented: true,
  isActive: false,
};

CollapsableContent.propTypes = {
  children: PropTypes.any.isRequired,
  element: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.element,
    PropTypes.func,
    PropTypes.string,
  ]).isRequired,
  indented: PropTypes.bool,
  isActive: PropTypes.bool,
  label: PropTypes.any,
  onClickClose: PropTypes.func,
  onClickOpen: PropTypes.func,
};

export default CollapsableContent;
